import { render, staticRenderFns } from "./CollegeSpecialtyZhuan.vue?vue&type=template&id=9a64ee98&scoped=true"
import script from "./CollegeSpecialtyZhuan.vue?vue&type=script&lang=js"
export * from "./CollegeSpecialtyZhuan.vue?vue&type=script&lang=js"
import style0 from "./CollegeSpecialtyZhuan.vue?vue&type=style&index=0&id=9a64ee98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a64ee98",
  null
  
)

export default component.exports